import { BrushOptions } from './BrushOptions';

const PATH = '.';

export const ATMOSPHERES = [
  {
    id: 'nature',
    title: 'in_the_sky', //defined in lang files
    soundtrack: require('url:../src/assets/atmosphere/nature/nature_soundscape.mp3'),
    card: `${PATH}/sky_card.json`,
    cardImage: require('url:../src/assets/images/sky.png'),
    bg: require('url:../src/assets/atmosphere/nature/nature_bg.jpg'),
    instrumentColors: ['#577FDF', '#EEBB27', '#91A7E4', '#FFFFFF'],
    noteGridColor: '#ffffff',
    videoUrl: require('url:../src/assets/atmosphere/nature/sky_loop.mp4'),
    reverbDecay: 4,
    brush: new BrushOptions({
      thickness: 1,
      lineRadius: 1.5,
      limitMultiplier: 3,
      friction: 0.1,
      hairLength: 10,
      gravity: 0,
      round: false,
      hairsOpacity: 0.8,
    }),
    averageBackgroundColor: '#6490c5',
  },
  {
    id: 'underwater',
    title: 'underwater', //defined in lang files
    soundtrack: require('url:../src/assets/atmosphere/underwater/underwater_soundscape.mp3'),
    card: `${PATH}/underwater_card.json`,
    cardImage: require('url:../src/assets/images/underwater.png'),
    bg: require('url:../src/assets/atmosphere/underwater/underwater_bg.jpg'),
    instrumentColors: ['#91D4E7', '#2B778E', '#FFFFFF', '#447F65'],
    noteGridColor: '#ffffff',
    videoUrl: require('url:../src/assets/atmosphere/underwater/underwater.mp4'),
    reverbDecay: 7,
    brush: new BrushOptions({
      thickness: 12,
      lineRadius: 1,
      limitMultiplier: 3,
      friction: 0.2,
      hairLength: 9,
      gravity: 0,
      round: true,
      hairsOpacity: 0.8,
    }),
    averageBackgroundColor: '#011a1e',
  },
  {
    id: 'hiphop',
    title: 'on_the_street', //defined in lang files
    soundtrack: require('url:../src/assets/atmosphere/hiphop/hiphop_soundscape.mp3'),
    card: `${PATH}/street_card.json`,
    cardImage: require('url:../src/assets/images/street.png'),
    bg: require('url:../src/assets/atmosphere/hiphop/hiphop_bg.jpg'),
    instrumentColors: ['#540E0D', '#B02F2D', '#285345', '#D7D7D7'],
    noteGridColor: '#ffffff',
    videoUrl: require('url:../src/assets/atmosphere/hiphop/hiphop.mp4'),
    reverbDecay: 5,
    brush: new BrushOptions({ isSpray: true, sprayFlow: 0.4 }),
    averageBackgroundColor: '#616a79',
  },
  {
    id: 'japanese',
    title: 'on_paper', //defined in lang files
    soundtrack: null,
    card: `${PATH}/caligraphy_card.json`,
    cardImage: require('url:../src/assets/images/caligraphy.png'),
    bg: require('url:../src/assets/atmosphere/japan/japanese_bg.jpg'),
    instrumentColors: ['#000000', '#4ca88d', '#dd86a7', '#b49d4c'],
    noteGridColor: '#000000',
    videoUrl: require('url:../src/assets/atmosphere/japan/japanese.mp4'),
    reverbDecay: 4.5,
    brush: new BrushOptions({
      thickness: 1,
      lineRadius: 4,
      limitMultiplier: 4,
      friction: 0.36,
      hairLength: 8,
      gravity: 0,
      round: false,
      hairsOpacity: 0.4,
    }),
    averageBackgroundColor: '#cec5b3',
  },
];
